import Swiper from "swiper";
import {Pagination} from "swiper/modules";

export const ourGallery = () => {
  if (document.querySelector('.our-gallery')) {
    const slider = document.querySelectorAll('.our-gallery__slider');
    slider.forEach((el, index) => {
      new Swiper(el, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 12,
        speed: 900,
        pagination: {
          el: document.querySelectorAll(`.our-gallery__pagination`)[index],
          clickable: true,
        },
        breakpoints: {
          1000: {
            slidesPerView: 3,
          },
          760: {
            slidesPerView: 2
          }
        }
      });
    });
  }
}